import { getLoadedEnv } from '@myre/common-conf';
import { LogType } from '@myre/common-logger';
import { DynamicEnvService } from '@myre/ui-domain-http';

import { HttpErrorResponse } from '@angular/common/http';
import {
  EnvironmentInjector,
  ErrorHandler,
  inject,
  Injectable,
} from '@angular/core';
import { Store, type ActionType } from '@ngrx/store';
import { captureException, captureMessage } from '@sentry/angular';

import { getLatestValue } from '../../helpers/observable.helpers';

import { loggedUserSelector, type AuthState } from '../auth/auth.service';

export function isActionError(error: any): error is ActionType<{ error: any }> {
  return (
    error &&
    'type' in error &&
    typeof error.type === 'string' &&
    'error' in error
  );
}

@Injectable({ providedIn: 'root' })
export class CustomErrorHandler extends ErrorHandler {
  private readonly _dynamicEnvService = inject(DynamicEnvService);
  private readonly _injector = inject(EnvironmentInjector);

  public override handleError(error: any): void {
    const store = this._injector.get(Store<AuthState>);
    const loggedUser = getLatestValue(store.select(loggedUserSelector));

    if (this._dynamicEnvService.env.errors.sentry) {
      const actualError =
        isActionError(error) || error instanceof HttpErrorResponse
          ? error.error
          : error;

      const user = loggedUser && {
        ...loggedUser,
        id: loggedUser.id.toString(),
      };

      captureException(actualError, {
        user,
      });
    }

    if (this._dynamicEnvService.env.errors.console) {
      super.handleError(error);
    }
  }
}

export function logMessage(
  logType: LogType,
  message: string,
  details?: any,
): void {
  const env = getLoadedEnv();

  if (env.errors.sentry) {
    captureMessage(message, {
      level: 'info',
      extra: {
        logType,
        details: details && JSON.stringify(details),
      },
    });
  }

  if (env.errors.console) {
    // @ts-expect-error, eslint-disable-next-line no-console
    console.log(`[${LogType[logType]}]`, message, details);
  }
}
